import api from './api'

class EmployeeAllowanceService {
  // Get all employee allowances
  async getAllEmployeeAllowances(params = {}) {
    try {
      const response = await api.get('/hr/employee-allowances', { params })
      console.log('Raw Employee Allowances API response:', response.data) // Debug log
      
      // Handle different possible response structures
      const data = response.data.data || response.data
      
      return {
        success: true,
        data: data,
        message: response.data.message || 'Employee allowances retrieved successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to retrieve employee allowances',
        error: error.response?.data
      }
    }
  }

  // Get employee allowance by ID
  async getEmployeeAllowanceById(allowanceId) {
    try {
      const response = await api.get(`/hr/employee-allowances/${allowanceId}`)
      console.log('Raw Employee Allowance by ID API response:', response.data) // Debug log
      
      // Handle different possible response structures
      const data = response.data.data || response.data
      
      return {
        success: true,
        data: data.allowance || data,
        message: response.data.message || 'Employee allowance retrieved successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to retrieve employee allowance',
        error: error.response?.data
      }
    }
  }

  // Create new employee allowance
  async createEmployeeAllowance(allowanceData) {
    try {
      const response = await api.post('/hr/employee-allowances', allowanceData)
      console.log('Raw Employee Allowance POST API response:', response.data) // Debug log
      
      // Handle different possible response structures
      const data = response.data.data || response.data
      
      return {
        success: true,
        data: data.allowance || data,
        message: response.data.message || 'Employee allowance created successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to create employee allowance',
        error: error.response?.data
      }
    }
  }

  // Update employee allowance
  async updateEmployeeAllowance(allowanceId, allowanceData) {
    try {
      const response = await api.patch(`/hr/employee-allowances/${allowanceId}`, allowanceData)
      console.log('Raw Employee Allowance PATCH API response:', response.data) // Debug log
      
      // Handle different possible response structures
      const data = response.data.data || response.data
      
      return {
        success: true,
        data: data.allowance || data,
        message: response.data.message || 'Employee allowance updated successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to update employee allowance',
        error: error.response?.data
      }
    }
  }

  // Delete employee allowance
  async deleteEmployeeAllowance(allowanceId) {
    try {
      const response = await api.delete(`/hr/employee-allowances/${allowanceId}`)
      return {
        success: true,
        message: response.data.message || 'Employee allowance deleted successfully'
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete employee allowance',
        error: error.response?.data
      }
    }
  }
}

const employeeAllowanceService = new EmployeeAllowanceService()
export default employeeAllowanceService
